import _                    from 'lodash'
import { parseISO, format } from 'date-fns'
import { utcToZonedTime }   from 'date-fns-tz'
import { navigate }         from "svelte-routing"
import { settings }         from './stores.js'
import validate             from 'validate.js'


validate.validators.custom = function(value, options, key, attributes) {
    if(attributes.anonymous) {
        return _.trim(value).length === 0 ? options.message : null
    }
}

let tz = 'America/Sao_Paulo'
settings.subscribe(v => {
    tz = v.timezone
})

const regex = /P([0-9]+)([YMD]{1})/i

export function companyChanged(selected) {
    const id = selected ? selected.value.id : null
    if(id) {
        navigate(`/empresa/${id}`)
    } else {
        navigate('/')
    }
    return id
}

export function copy(text) {
    return function() {
        return navigator
            .clipboard
            .writeText(text)
            .catch( e => console.error('Error copying value: '+text))
    }
}

/*
 * See: https://www.npmjs.com/package/date-fns-tz
 */
export function parseDate(str) {
    const iso   = parseISO(str+'Z')
    const zoned = utcToZonedTime(iso, tz)
    return format(zoned, "HH:mm:ss dd/MM/yyyy")
}

export function sanitize(str) {
    return _
    .trim(str)
    .replaceAll(" ", "-")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // removes the accents
    .replace(/[^a-z0-9_\-]/g, '')    // removes non alphanumeric
}

export function erased(str) {
    const len = str.length
    return str.substring(0, len - 7) + " (removido)"
}

export function assignDuration(it, prop) {
    const m = prop && prop.match(regex)
    if(m) {
        it.duration = m[1]
        it.unit     = m[2]
    } else {
        it.duration = null
        it.unit     = null
    }
    return it
}